// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
}

.tab-panel {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  overflow: hidden;
}
@media only screen and (max-width: 1200px) {
  .tab-panel .desktop-label {
    display: none;
  }
}
@media only screen and (max-width: 1200px) {
  :host(.tab-panel-host_keep-labels-on-narrow) .tab-panel .desktop-label {
    display: inline;
  }
}
.tab-panel__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.tab-panel .tab-panel__head {
  flex: 0 0 auto;
  background: var(--colorBgLevel4);
  border-bottom: 1px solid var(--colorBg);
  padding: 16px 48px 0 0px;
}
.tab-panel .tab-panel__head .close-button {
  position: absolute;
  right: 0;
  top: 8px;
}
.tab-panel .tab-panel__head .tabs, .tab-panel .tab-panel__head .tab {
  width: auto;
}
.tab-panel .tab-panel__head .tabs {
  padding: 0 8px 0 0;
  position: relative;
  white-space: nowrap;
}
.tab-panel .tab-panel__head .tabs a {
  text-decoration: none;
  font-size: 16px;
  padding: 4px 8px 6px;
  display: inline-block;
  border-bottom: 3px solid transparent;
}
.tab-panel .tab-panel__head .tabs .tab.selected {
  border-bottom: 3px solid var(--colorBgPrimary);
  color: var(--colorBgInverse);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
